// extracted by mini-css-extract-plugin
export var actions = "_mm-5";
export var assistantBubble = "_mm-3";
export var assistantRow = "_mm-6";
export var bubble = "_mm-0";
export var humanAvatar = "_mm-4";
export var inlineToolCard = "_mm-1";
export var userBubble = "_mm-2";